import React, { PropTypes } from 'react'

// const LeftComponent = () => (
//   <div className="container_bg">
//     <div className="container_bg_info">
//       <h2>Delivering Medical Education </h2>
//       <p>ONLINE · IN-PERSON · ON DEMAND</p>
//       <div className="container_images">
//         <img className="container_bg_icons" src="/assets/img/pattern.svg" alt="bg" />
//         <img className="container_bg_mac" src="/assets/img/landing-top-notebook.png" alt="mac" />
//       </div>
//     </div>
//   </div>
// )

const LeftComponent = () => (
	<div className="bg_landing_main auth_page">
		<div className="bg_landing">
		<svg preserveAspectRatio="none" height={390} id="svg" viewBox="0 0 1440 390" xmlns="http://www.w3.org/2000/svg" className="transition duration-300 ease-in-out delay-150"><path d="M 0,400 C 0,400 0,200 0,200 C 181.19999999999993,197.73333333333335 362.39999999999986,195.46666666666667 542,210 C 721.6000000000001,224.53333333333333 899.6000000000001,255.86666666666667 1049,257 C 1198.3999999999999,258.1333333333333 1319.1999999999998,229.06666666666666 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" strokeWidth="0" fill="#fff" fillOpacity="1" className="transition-all duration-300 ease-in-out delay-150 path-0"></path></svg>
		</div>
		<div className='heroMain'>
		<div className='info'>
			<h2>Delivering Medical Education</h2>
			<div className='divider' />
			<ul>
				<li>Online</li>
				<strong />
				<li>In-Person</li>
				<strong />
				<li>On Demand</li>
			</ul>
		</div>
		</div>
		<div className="landing_info">
			<div className="landing_section_info">
				<img src="/assets/img/cpd-hours.png" alt="image"/>
				<h3>Interactive Sessions</h3>
				<p>Ask questions and receive answers in real time</p>
			</div>
			<div className="landing_section_info">
				<img src="/assets/img/free.png" alt="image"/>
				<h3>On Demand</h3>
				<p>Watch on your desktop, tablet or phone anywhere & anytime</p>
			</div>
			<div className="landing_section_info">
				<img src="/assets/img/local.png" alt="image"/>
				<h3>Hybrid Meetings</h3>
				<p>Your choice of online & in-person events</p>
			</div>
			<div className="landing_section_info">
				<img src="/assets/img/cpd-hours.png" alt="image"/>
				<h3>CPD Locker</h3>
				<p>Accredited webinars & live streams all in one place</p>
			</div>
		</div>
	</div>
)
// LeftComponent.propTypes = {
//   todos: PropTypes.arrayOf(PropTypes.shape({
//     id: PropTypes.number.isRequired,
//     completed: PropTypes.bool.isRequired,
//     text: PropTypes.string.isRequired
//   }).isRequired).isRequired,
//   onTodoClick: PropTypes.func.isRequired
// }

export default LeftComponent



// WEBPACK FOOTER //
// ./src/components/Authorization/LeftComponent.js